import { Injectable } from '@angular/core';
import { UtilService } from '@service/util/util.service';
import { CarrierSearchQuery } from '@domain/interface/carrier-search-query';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class CarrierSearchHelperService {
	SEPARATION_KEYS = [':', '-'];

	constructor(private utilService: UtilService) {}

	resetSearchObject(): CarrierSearchQuery {
		return {
			businessName: null,
			emailAddress: null,
			mc: null,
			dot: null,
			phone: null,
			customerCode: null,
			inNetwork: true,
			trailerTypes: null,
			carrierHQLatitude: null,
			carrierHQLongitude: null,
			city: null,
			state: null,
			zip: null,
			powerUnits: null,
			projectIds: [],
			notesContent: null,
			hazmat: false,
			assignedToMe: false,
			hasTeams: false,
			ignoreContactCount: true
		};
	}

	populateSearchObject(
		formValue: {
			searchText: string;
			inNetwork: boolean;
			powerUnits: number;
			hazmat: boolean;
			assignedToMe: boolean;
			hasTeams: boolean;
		},
		selectedTrailerTypes: Array<string>,
		carrierHQ: any,
		selectedProjectIds: string[]
	): CarrierSearchQuery {
		let searchObject = Object.assign({}, this.resetSearchObject());
		const textSplit = formValue.searchText.split(',');
		textSplit?.forEach((text) => {
			if (this.isKey(text, 'mc')) {
				searchObject.mc = this.splitOutValue(text);
			} else if (this.isKey(text, 'dot')) {
				searchObject.dot = this.splitOutValue(text);
			} else if (this.isKey(text, 'code')) {
				searchObject.customerCode = this.splitOutValue(text);
			} else if (this.isEmail(text)) {
				searchObject.emailAddress = text.trim();
			} else if (this.isPhone(text)) {
				searchObject.phone = text.trim();
			} else if(this.isDotOrMc(text))
			{
				searchObject.dot = text;
				searchObject.mc = text;
			} 
			else {
				searchObject.businessName = text.trim();
			}
		});
		searchObject.inNetwork = searchObject.customerCode ? true : formValue.inNetwork;
		searchObject.trailerTypes = selectedTrailerTypes.join(',');
		searchObject.powerUnits = formValue.powerUnits;
		if (!this.utilService.isNullOrUndefined(carrierHQ)) {
			searchObject.city = carrierHQ.city ? carrierHQ.city : null;
			searchObject.state = carrierHQ.state ? carrierHQ.state : null;
			searchObject.zip = carrierHQ.zip ? carrierHQ.zip : null;
			searchObject.carrierHQLatitude = carrierHQ.latitude ? carrierHQ.latitude : null;
			searchObject.carrierHQLongitude = carrierHQ.longitude ? carrierHQ.longitude : null;
		}
		searchObject.projectIds = selectedProjectIds.filter((projectId) => IS_NOT_EMPTY(projectId));
		searchObject.notesContent = formValue.searchText;
		searchObject.hazmat = formValue.hazmat;
		searchObject.assignedToMe = formValue?.assignedToMe ? true : false;
		searchObject.hasTeams = formValue.hasTeams;
		return searchObject;
	}

	isKey(text: string, keyName: string): boolean {
		for (const separationKey of this.SEPARATION_KEYS) {
			if (
				text.includes(separationKey) &&
				text.trim().toLowerCase().startsWith(`${keyName}${separationKey}`)
			) {
				return true;
			}
		}
		return false;
	}

	splitOutValue(text: string): string {
		for (const key of this.SEPARATION_KEYS) {
			if (text.includes(key)) {
				return text.split(key)[1].trim();
			}
		}
	}

	isEmail(text: string): boolean {
		return this.utilService.isValidEmail(text.trim());
	}

	isPhone(text: string): boolean {
		return this.utilService.isValidPhone(text.trim());
	}

	isDotOrMc(text: string): boolean{
		return this.utilService.isValidNumber(text);
	}
}
